import React from 'react';
import '../../styles/IntegrationCircle.css';
import linkedin from '../../assets/images/linkedin.jpg';
import logo from '../../assets/images/logonew.png';
import slack from '../../assets/images/slack.jpg';
import teams from '../../assets/images/teams.png';
import discord from '../../assets/images/discord (2).png';
import gmail from '../../assets/images/gmail.png';
import google from '../../assets/images/google.png';

const tools = [
  { src: google, alt: 'Google Meet', angle: -90 },
  { src: linkedin, alt: 'LinkedIn', angle: -30 },
  { src: slack, alt: 'Slack', angle: 30 },
  { src: teams, alt: 'Microsoft Teams', angle: 90 },
  { src: discord, alt: 'Discord', angle: 150 },
  { src: gmail, alt: 'Gmail', angle: 210 },
];

const IntegrationCircle = () => {
  return (
    <div className="comm-hub">
      <div className="comm-hub__glow" aria-hidden="true" />
      <div className="comm-hub__ring comm-hub__ring--outer" aria-hidden="true" />
      <div className="comm-hub__ring comm-hub__ring--inner" aria-hidden="true" />

      <div className="comm-hub__center">
        <div className="comm-hub__center-pulse" aria-hidden="true" />
        <img src={logo} alt="NeoApps" className="comm-hub__logo" />
        <span className="comm-hub__label">Your hub</span>
      </div>

      <div className="comm-hub__orbit">
        <ul className="comm-hub__tools">
          {tools.map((tool) => (
            <li
              key={tool.alt}
              className="comm-hub__tool"
              style={{ '--angle': `${tool.angle}deg` }}
            >
              <div className="comm-hub__tool-inner">
                <img src={tool.src} alt={tool.alt} />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default IntegrationCircle;
